import { createSelector } from 'reselect'

import { selectPlanningWizardState } from './selectPlanningWizardState'

export const selectWizardIsVisible = createSelector(
  [selectPlanningWizardState],
  (planningWizard) => planningWizard.isVisible
)
